module.exports = __webpack_public_path__ + "static/media/santiagoaragon.a249c337.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/santiagoaragon.webp
// module id = 829
// module chunks = 0